import React, {
    ReactElement, useState,
    useEffect,
} from "react";
import Player from "../../../components/LottiePlayer";

import useRouting, { useParams } from "../../../contexts/Routing";
import useCurrentSession from "../../../contexts/UserContext";
import { Permission, useLoginWithTokenMutation } from "../../../__generated__/api";
import lottieImg from "../../../assets/lottie/robot.lottie";

export default function LoginWithToken(): ReactElement {
    const { invalidate } = useCurrentSession();
    const { Paths, historyPushWithSearch } = useRouting();
    const { token } = useParams(Paths.LOGIN_WITH_TOKEN);
    const [loginError, setLoginError] = useState<string | null>();
    const [loginHandler] = useLoginWithTokenMutation();

    useEffect(() => {
        const handle = async () => {
            try {
                const response = await loginHandler({ variables: { token } });
                if (response.data?.loginWithToken.__typename === "LoginError") {
                    setLoginError("Invalid or expired token");
                } else {
                    invalidate();

                    let redirectPath: string;
                    const permissions = new Set(response.data?.loginWithToken.permissions);
                    if (permissions.has(Permission.ChatsModify)) {
                        redirectPath = Paths.AGENT;
                    } else if (permissions.has(Permission.TicketsReadSelf)) {
                        redirectPath = Paths.TICKETS;
                    } else {
                        redirectPath = Paths.ANSWERS_LIST;
                    }

                    historyPushWithSearch(Paths.HOME, {
                        isWaitLogin: "true",
                        redirect: redirectPath,
                    });
                }
            } catch (err) {
                setLoginError((err as {message: string}).message);
            }
        };
        handle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div className="full-page">
            <div className="centered-container centered-container-md pt-5">
                <Player
                    autoplay
                    loop
                    src={lottieImg}
                    className="player"
                />

                {loginError ? (
                    <div>{loginError}</div>
                ) : (
                    <h3 className="mb-4">Logging in...</h3>
                )}

            </div>
        </div>
    );
}
